// Einfacher Dialog (Anruf protokollieren, Tastenkürzel). Escape schließt, Fokus auf das erste Feld.
import { useEffect, useRef, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { ebene } from "../werkzeuge/tasten";
import { Icon } from "./Icon";

interface Props {
  titel: string;
  offen: boolean;
  onSchliessen: () => void;
  children: ReactNode;
  fuss?: ReactNode;
  breite?: number;
}

export function Dialog({ titel, offen, onSchliessen, children, fuss, breite = 520 }: Props) {
  const box = useRef<HTMLDivElement>(null);
  const zu = useRef(onSchliessen);
  zu.current = onSchliessen;

  useEffect(() => {
    if (!offen) return;
    ebene.auf();
    const vorher = document.activeElement as HTMLElement | null;
    window.setTimeout(() => {
      const erstes = box.current?.querySelector<HTMLElement>("input, textarea, select, button.auswahl__knopf, [data-autofocus]");
      (erstes ?? box.current)?.focus();
    }, 0);
    const taste = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        zu.current();
      }
    };
    window.addEventListener("keydown", taste);
    return () => {
      ebene.zu();
      window.removeEventListener("keydown", taste);
      vorher?.focus?.();
    };
  }, [offen]);

  if (!offen) return null;
  return createPortal(
    <div
      className="dialog-hintergrund"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) zu.current();
      }}
    >
      <div ref={box} className="dialog" style={{ width: `min(${breite}px, calc(100vw - 32px))` }} role="dialog" aria-modal="true" aria-label={titel} tabIndex={-1}>
        <div className="dialog__kopf">
          <h2>{titel}</h2>
          <button type="button" className="symbolknopf" aria-label="Schließen" onClick={() => zu.current()}>
            <Icon name="schliessen" groesse={16} />
          </button>
        </div>
        <div className="dialog__inhalt">{children}</div>
        {fuss ? <div className="dialog__fuss">{fuss}</div> : null}
      </div>
    </div>,
    document.body,
  );
}
